// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import getAddedToBagFormValues from '../../../../../reduxStore/selectors/form.selectors';

export const getAccessories = (state) => {
  return state.Accessories && state?.Accessories?.accessories;
};

export const getSecondaryAccessories = (state) => {
  return state.Accessories && state?.Accessories?.secondaryAccessories;
};

export const getSecondarySelectedAccessories = (state) => {
  return state.Accessories && state?.Accessories?.secondarySelectedAccessories;
};

export const getSelectedAccessories = (state) => {
  return state.Accessories && state?.Accessories?.selectedAccessory;
};

export const getParentAccessories = (state) => {
  return state && state?.Accessories?.parentAccessories;
};
export const getParentCustomizationType = (state) => {
  return state && state?.Accessories?.parentCustomizationType;
};
export const getUpdateType = (state) => {
  return state && state?.Accessories?.updateFromQV;
};
export const get00007Error = (state) => {
  return state && state?.Accessories?.show0007Error;
};
export const getCurrentHighlightedIndex = (state) => {
  return state && state?.Accessories?.currentHighlightedIndex;
};
export const getSecondaryAccessoryDetailFromState = (state) => {
  return state && state?.Accessories?.secondaryAccessoryDetail;
};

export const getSecondaryAccessoryGeneralProductId = (state) => {
  return (
    state?.Accessories?.secondaryAccessoryDetail &&
    state?.Accessories?.secondaryAccessoryDetail?.generalProductId
  );
};

const selectStateForm = (state) => (state && state.form ? state.form : {});

export const getSecondaryAccessoryFormValues = createSelector(
  selectStateForm,
  getSecondaryAccessoryGeneralProductId,
  (stateForm, generalProductId) => {
    return getAddedToBagFormValues(stateForm, `secondAccessoryForm-${generalProductId}`);
  }
);
export const get00007ErrorSecondary = (state) => {
  return state && state?.Accessories?.show0007ErrorSecondaryAccessories;
};

export const getSecondaryAccessoryDetail = (state) => {
  return state && state.Accessories?.secondaryAccessoryDetail;
};

export const getTempSelectedSecondaryAccessories = (state) => {
  return state && state.Accessories?.tempSecondarySelectedAccessories;
};

export const getGrandParentId = (state) => {
  return state && state?.Accessories?.grandParentId;
};

export const getVarientCount = (state) => {
  return (state && state.Accessories?.varientCount) || null;
};

export const getSizeError = (state) => {
  return state && state?.Accessories?.sizeError;
};

export const getGrandParentSize = (state) => {
  return state && state?.Accessories?.grandParentSize;
};

export const getDeselectSize = (state) => {
  return state && state?.Accessories?.deselectSize;
};

export const getGrandParentScreen = (state) => {
  return state && state?.Accessories?.grandParentScreen;
};

export const getGrandParentColor = (state) => {
  return state && state?.Accessories?.grandParentColor;
};

export const getGrandParentFit = (state) => {
  return state && state?.Accessories?.grandParentFit;
};

export const getGrandParentQuantity = (state) => {
  return state && state?.Accessories?.grandParentQuantity;
};
